import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import client, { inr, API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user, checked, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) client.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user]);

  if (checked && !user) return <Navigate to="/login" replace />;
  if (!user) return <div className="pt-40 text-center">Loading…</div>;

  return (
    <div className="pt-32 pb-24 max-w-[1600px] mx-auto px-6 md:px-12" data-testid="account-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">
            Your account
          </div>
          <h1 className="font-serif-display text-5xl md:text-6xl font-light leading-none">
            Hello, {user.name.split(" ")[0]}.
          </h1>
          <p className="mt-3 text-[#7B6F66]">{user.email}</p>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="self-start border border-[#1C3326] hover:bg-[#1C3326] hover:text-[#FDFBF7] px-8 py-3 uppercase text-xs tracking-[0.25em] font-medium transition-colors"
        >
          Sign out
        </button>
      </div>

      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-6">
          Your orders
        </div>
        {orders.length === 0 ? (
          <div className="border border-[#EBE3D5] p-16 text-center">
            <p className="font-serif-display text-3xl text-[#7B6F66]">No orders yet.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div
                key={o.id}
                data-testid={`order-${o.order_number}`}
                className="border border-[#EBE3D5] p-6 md:p-8"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.25em] text-[#7B6F66]">
                      {new Date(o.created_at).toLocaleDateString()} · {o.status}
                    </div>
                    <div className="font-serif-display text-2xl">{o.order_number}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-[10px] uppercase tracking-[0.25em] text-[#7B6F66]">Total</div>
                    <div className="font-serif-display text-2xl">{inr(o.total)}</div>
                  </div>
                </div>
                <div className="mt-6 border-t border-[#EBE3D5] pt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {o.items.map((it, i) => (
                    <div key={i} className="text-sm text-[#4A3B32]">
                      · {it.name} {it.variant && `(${it.variant})`} × {it.quantity}
                    </div>
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-[#EBE3D5] flex flex-wrap gap-3">
                  <a
                    href={`${API}/orders/${o.id}/invoice.pdf`}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`account-invoice-${o.order_number}`}
                    className="text-xs uppercase tracking-[0.2em] text-[#C85A32] link-underline"
                  >
                    Download invoice
                  </a>
                  {o.awb_code && (
                    <span className="text-xs uppercase tracking-[0.2em] text-[#7B6F66]">
                      AWB · {o.awb_code}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
